// Resolves the backend base URL. Configurable via VITE_BACKEND_URL (Vite only
// exposes env vars prefixed VITE_ to client code), defaulting to the local
// tmc-abstract-images-backend dev port (23503).
export const configUrls = () => {
  const backendUrl = import.meta.env.VITE_BACKEND_URL || 'http://localhost:23503';
  return {
    BACKEND_GQL: `${backendUrl}/graphiql`,
    BACKEND_REST: `${backendUrl}/api`,
  };
};

export default { configUrls };
